import { render, staticRenderFns } from "./zlw.vue?vue&type=template&id=b193ee20&scoped=true&"
var script = {}
import style0 from "./zlw.vue?vue&type=style&index=0&id=b193ee20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b193ee20",
  null
  
)

export default component.exports